import theme from '../base'

const popover = {
  MuiPopover: {
    styleOverrides: {
      root: {
        '& .MuiBackdrop-root': { backgroundColor: 'transparent' },
      },
      paper: {
        display: 'flex',
        minWidth: 160,
        maxWidth: 300,
        padding: theme.spacing(1.5, 2),
        ...theme.typography.body2,
        color: theme.palette.neutral.white,
        boxShadow: theme.shadows[2],
        borderRadius: 0,
        '& svg': {
          minWidth: 25,
          height: 25,
          marginRight: theme.spacing(1),
        },
        '& .MuiMenuItem-root:hover': {
          backgroundColor: theme.palette.neutral.lightest,
        },
        '& .content': {
          display: 'flex',
          flexDirection: 'column',
          '& .MuiLink-root': {
            margin: theme.spacing(0.5, 0, 0, 'auto'),
            ...theme.typography.body2,
            color: 'inherit',
          },
          '& .MuiButton-root': {
            margin: theme.spacing(0.5, 0, 0, 'auto'),
          },
          '& .MuiTypography-h3medium': {
            marginBottom: theme.spacing(0.5),
          },
        },
        '&.error': {
          backgroundColor: theme.palette.error.light,
          color: theme.palette.error.dark,
        },
        '&.warning': {
          backgroundColor: theme.palette.warning.light,
          color: theme.palette.warning.darkest,
          '& .MuiLink-root': {
            '&::after': {
              backgroundColor: theme.palette.warning.darkest,
            },
          },
        },
        '&.info': {
          backgroundColor: theme.palette.info.light,
          color: theme.palette.info.darkest,
          '& .MuiLink-root': {
            '&::after': {
              backgroundColor: theme.palette.info.darkest,
            },
          },
        },
      },
    },
  },
}

export default popover
